import { CheckboxesNested } from '@/types/home/home.types';
import { atom } from 'recoil';

export const priceCheckboxesState = atom<CheckboxesNested[]>({
  key: 'priceCheckboxesState',
  default: [],
});

export const mileageCheckboxesState = atom<CheckboxesNested[]>({
  key: 'mileageCheckboxesState',
  default: [],
});

export const currentPagePath = atom<string | null>({
  key: 'currentPagePath',
  default: null,
});
